const Share = {
  open: async (options) => {
    if (typeof navigator !== 'undefined' && navigator.share) {
      return navigator.share(options);
    }
    return true;
  },
  shareSingle: async () => true,
  isPackageInstalled: async () => false,
};

module.exports = Share;
module.exports.default = Share;
